module.exports = __webpack_public_path__ + "img/warning.6d2ccfc5.png";